export const RESERVATION_STATE_VALUES = {
    ON_USE: 1,
    FINALIZED: 2
};
export const RESERVATION_STATES = [
    {
        value: RESERVATION_STATE_VALUES.ON_USE,
        label: "En uso"
    },
    {
        value: RESERVATION_STATE_VALUES.FINALIZED,
        label: "Finalizó"
    }
];
export const TOAST_MESSAGES = {
    SAVE_RESERVATION_STATE: "¡Se cambió exitosamente el estado de la reserva!",
    UPDATE_PENALTY_STUDENT: "¡Se editó exitosamente la sanción del alumno!"
};
export const ERROR_ADD_STUDENT_TO_GROUP_RESERVATION = {
    STUDENT_ADDED: "ALUMNO_YA_AGREGADO",
    ERROR_TO_ADDING: "ERROR_AL_AGREGAR"
};